// extracted by mini-css-extract-plugin
module.exports =  {"close-profile":"ldapFieldsMap__close-profile","label-item":"ldapFieldsMap__label-item"};